"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormOkResponseSchema = exports.FormDownloadUrlResponseSchema = exports.RequestAttachmentUploadResponseSchema = exports.FormAttachmentListResponseSchema = exports.FormSaveDraftConflictSchema = exports.FormDraftRevisionResponseSchema = exports.FormSaveDraftResponseSchema = exports.FormLoadDraftResponseSchema = exports.FormSubmitResponseSchema = void 0;
const zod_1 = require("zod");
const form_definition_1 = require("./form-definition");
const form_records_1 = require("./form-records");
// Response + cross-boundary envelope schemas for the form endpoints. These are
// the single source of truth the React service and the Nest controllers share,
// so a renamed/added/removed response field is a type error on both sides
// rather than silent FE↔BE drift.
exports.FormSubmitResponseSchema = zod_1.z.object({
    submissionId: zod_1.z.string(),
    // Absent on slug-wide paths — see FormSubmissionRecord.submissionVersion.
    submissionVersion: zod_1.z.number().int().optional(),
    scores: form_definition_1.FormComputedScoresSchema,
});
exports.FormLoadDraftResponseSchema = zod_1.z.object({
    draft: form_records_1.FormDraftRecordSchema.nullable(),
    currentVersion: zod_1.z.number().int(),
    // Set when the loaded draft predates the current form version.
    staleSinceVersion: zod_1.z.number().int().nullable(),
    droppedFields: zod_1.z.array(zod_1.z.string()),
});
exports.FormSaveDraftResponseSchema = zod_1.z.object({
    draft: form_records_1.FormDraftRecordSchema,
});
// Polled every 15s by the form filler — draft metadata only, no answers.
exports.FormDraftRevisionResponseSchema = zod_1.z.object({
    revision: zod_1.z.number().int().nullable(),
    updatedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastEditorUserId: zod_1.z.string().nullable(),
    lastEditorDisplayName: zod_1.z.string().nullable(),
});
// Body the save-draft endpoint returns with a 409 when a teammate saved first.
// `current` echoes the server-held draft so the client can adopt it.
exports.FormSaveDraftConflictSchema = zod_1.z.object({
    code: zod_1.z.literal('DRAFT_REVISION_CONFLICT'),
    current: form_records_1.FormDraftRecordSchema,
});
exports.FormAttachmentListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(form_records_1.FormAttachmentRecordSchema),
});
exports.RequestAttachmentUploadResponseSchema = zod_1.z.object({
    attachmentId: zod_1.z.string(),
    storageObjectVersionId: zod_1.z.string(),
    uploadUrl: zod_1.z.string(),
});
exports.FormDownloadUrlResponseSchema = zod_1.z.object({
    url: zod_1.z.string(),
});
// Shared by confirm-state, delete-attachment, and delete-draft.
exports.FormOkResponseSchema = zod_1.z.object({
    ok: zod_1.z.boolean(),
});
